import { RESOURCE_ROUTE_BY_TYPE } from '../constants.js';

// Función para construir la URL de detalle de un recurso a partir de su tipo y rastro de ids.
const buildResourceUrl = (resourceType, path) => {
  const routeType = RESOURCE_ROUTE_BY_TYPE[resourceType];
  if (!routeType || !Array.isArray(path) || path.length === 0) {
    return null;
  }
  return `/resources/${routeType}/detail/${path.map(encodeURIComponent).join('/')}`;
};

// Función para generar el nombre del profesor a partir de su objeto, con manejo de valores nulos.
const teacherName = teacher => {
  if (!teacher) return '-';
  return `${teacher.firstnames ?? ''} ${teacher.lastnames ?? ''}`.trim() || '-';
};

// Config de las tarjetas de estadísticas: solo labels y estilos, indexado por la
// misma key que devuelve el backend en `stats`. Los valores (conteos) vienen del
// backend; los íconos se inyectan en el componente (STAT_ICONS).
const STATS = [
  { key: 'units', label: 'Unidades', tile: 'bg-blue-100 text-primary', valueColor: 'text-primary' },
  {
    key: 'images',
    label: 'Imágenes',
    tile: 'bg-blue-100 text-blue-700',
    valueColor: 'text-blue-700',
  },
  {
    key: 'videos',
    label: 'Videos',
    tile: 'bg-green-100 text-green-700',
    valueColor: 'text-green-700',
  },
  {
    key: 'anatomical_structures',
    label: 'Estructuras Anatómicas',
    tile: 'bg-purple-100 text-purple-700',
    valueColor: 'text-purple-700',
  },
];

export { buildResourceUrl, teacherName, STATS };
